import { WithQueryUserListItemTitle } from './with-query-user-list-item-title'
import { WithQueryUserListItemStatus } from './with-query-user-list-item-status'
import { nothing } from '$func/utils'
import { UserListItem } from '$common/user-list-item'
import { usePv } from '$logic/pv/react-hook'

interface Props {
  roomId: string
  hasDivider?: boolean
  onClick?: () => unknown
  onContextMenu?: (e: Event) => unknown
  selected?: boolean
  searchQuery: string
}

export function SearchedPvListItemWithStatus({
  roomId,
  hasDivider = true,
  onClick = nothing,
  onContextMenu = nothing,
  selected = false,
  searchQuery,
}: Props) {
  const { entity: pv } = usePv(roomId)
  return (
    <UserListItem
      userId={pv?.to}
      primaryText={
        <WithQueryUserListItemTitle userId={pv?.to} query={searchQuery} />
      }
      secondaryText={
        <WithQueryUserListItemStatus userId={pv?.to} query={searchQuery} />
      }
      hasDivider={hasDivider}
      onClick={onClick}
      onContextMenu={onContextMenu}
      selected={selected}
    />
  )
}
